export const capitalizeString = input =>
  input ? input.charAt(0).toUpperCase() + input.slice(1) : "";
